import { render, staticRenderFns } from "./UserSettingInvoiceStyle.vue?vue&type=template&id=53e8d30a&scoped=true&"
import script from "./UserSettingInvoiceStyle.vue?vue&type=script&lang=js&"
export * from "./UserSettingInvoiceStyle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53e8d30a",
  null
  
)

export default component.exports